/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.unitModule')
  .controller('CreateCollectionController', [
    '$interval',
    '$q',
    '$state',
    '$window',
    'Restangular',
    'BulbAuthService',
    'BulbBusyService',
    'BulbErrorService',
    'BulbUnitService',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    CreateCollectionController,
  ]);

function CreateCollectionController(
  $interval,
  $q,
  $state,
  $window,
  Restangular,
  BulbAuthService,
  BulbBusyService,
  BulbErrorService,
  BulbUnitService,
) {
  const that = this;
  // DO LATER : rather than having just a 'PUBLIC' option, make an opposite version 'Just Me' that is selected if
  // 'Public' is not selected, and vice versa.

  /**
   * The create unit model.
   */
  this.unit = {
    name: '',
    description: '',
    readAccessSubjectIds: [],
  };

  /**
   * The array of selected choices for the 'visibility' control.
   */
  this.selectedVisibilityChoices = [];

  if (BulbUnitService.currentUnit && BulbUnitService.currentUnit.id) {
    this.parentUnitId = BulbUnitService.currentUnit.id;
  } else {
    this.parentUnitId = BulbAuthService.currentUser.authorUnitId;
  }

  /**
   * Sends a create request to the server with the new collection unit model information.
   */
  this.createCollection = function createCollection() {
    that.selectedVisibilityChoices.forEach((selection) => {
      if (!selection.inheritance) {
        that.unit.readAccessSubjectIds.push(selection.subjectId);
      }
    });

    BulbBusyService.showBusyDuring(
      // DO LATER : this should eventually be a standard POST to 'units' rather than what we are using here.
      // However, there is handler for that url that doesn't work for RESTful creation of collections yet.
      Restangular.one('units', that.parentUnitId).customPOST(that.unit, 'children').then((unit) => {
        // Navigate to the new unit page
        $state.go('unit', { unitPath: unit.path }, { location: 'replace' });
      }, (error) => {
        BulbErrorService.error('Unable to create a new collection', error);
        // DO LATER : handle error cleanly for user.
      }),
    );
  };

  /**
   * Back function for the Cancel button.
   */
  this.back = function back() {
    $window.history.back();
  };
}
